import { Button, ButtonGroup, Grid } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import { Alert } from "@material-ui/lab";
import React from "react";
import { connect } from "react-redux";
import { CustomerGroupListItem } from "src/lib/models/CustomerGroupListItem";

import { StoreState } from "../../store";

function mapStateToProps({ customerGroupEditOption }: StoreState) {
  return {
    customerGroupEditOption,
  };
}
type Props = {
  activeCustomerGroup: CustomerGroupListItem | null;
  onEditClick: () => void;
  onCloseClick: () => void;
} & ReturnType<typeof mapStateToProps>;

class ActiveCustomerGroupHint extends React.Component<Props> {
  public render(): JSX.Element {
    return (
      <Grid container={true} justify="flex-end">
        {this.props.activeCustomerGroup ? (
          <Alert severity="info">
            {
              <>
                Sie benutzen die Filtereinstellungen der Kundengruppe{" "}
                <b>{this.props.activeCustomerGroup.groupName}</b>
              </>
            }
          </Alert>
        ) : this.props.customerGroupEditOption ? (
          <Alert severity="info" icon={false}>
            <Grid container={true} alignItems="center" spacing={2}>
              <Grid item={true}>
                {
                  <>
                    Möchten Sie die neuen Einstellungen als Kundengruppe{" "}
                    <b>{this.props.customerGroupEditOption.groupName}</b>{" "}
                    speichern?
                  </>
                }
              </Grid>
              <Grid item={true}>
                <ButtonGroup>
                  <Button
                    color="secondary"
                    variant="outlined"
                    onClick={() => this.props.onEditClick()}
                  >
                    <CheckIcon />
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    onClick={() => this.props.onCloseClick()}
                  >
                    <ClearIcon />
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          </Alert>
        ) : (
          <></>
        )}
      </Grid>
    );
  }
}

export default connect(mapStateToProps)(ActiveCustomerGroupHint);



// WEBPACK FOOTER //
// ./src/components/CustomerGroups/ActiveCustomerGroupHint.tsx